import featureActionName from 'store/utils';

import { FEATURE_NAME } from './consts';

export const dateWithoutTime = (date) => {
  const res = new Date(date);

  res.setHours(0);
  res.setMinutes(0);
  res.setSeconds(0);
  res.setMilliseconds(0);

  return Date.parse(res);
};

export const actionName = featureActionName(FEATURE_NAME);

export const testUbsDomain = (email) => typeof email === 'string' && /.+@ubs\.com$/i.test(email.trim());
export const testFintoolDomain = (email) => typeof email === 'string' && /.+@fintool\.ch$/i.test(email.trim());
export const testSpecificDomain = (email) => typeof email === 'string' && /.+@(six-group|ubs)\.com$/i.test(email.trim());
